import React from 'react';
import { Container, AnimatedDots } from './styles';
import hpLogoImg from 'src/assets/images/Logo.svg';
import useShellRootContext from 'src/contexts/ShellRoot/useShellRootContext';

export const FinishingSetupScreen: React.FC = () => {
  const { t } = useShellRootContext();

  return (
    <Container>
      <img
        src={hpLogoImg}
        alt="HP Logo"
      />
      <h2>
        {t('loadingScreen.finishingSetup', 'We are finishing your setup')}
        <AnimatedDots />
      </h2>
    </Container>
  );
};
